/**
 * Noël — script léger (vanilla, ~1 ko)
 * - Neige limitée à la première section (option « page d'accueil »)
 * - Apparitions au défilement via IntersectionObserver
 * Rien ne s'exécute si l'utilisateur a demandé moins d'animations.
 */
(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = window.Shopify && window.Shopify.designMode;

  // Neige : on la place dans la première section du contenu (le hero).
  const snow = document.querySelector('[data-noel-snow="section"]');
  if (snow) {
    const firstSection = document.querySelector('#contenu-principal > .shopify-section');
    if (firstSection && !reduceMotion) {
      firstSection.style.position = 'relative';
      snow.classList.add('noel-snow--section');
      firstSection.appendChild(snow);
    } else {
      snow.remove();
    }
  }

  // Apparitions au défilement
  if (!root.dataset.noelReveal || reduceMotion || inEditor || !('IntersectionObserver' in window)) return;

  const sections = Array.from(document.querySelectorAll('#contenu-principal > .shopify-section')).slice(1);
  if (!sections.length) return;

  root.classList.add('noel-js');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  sections.forEach((section) => {
    section.classList.add('noel-reveal');
    observer.observe(section);
  });
})();
